(function () {
  const stickyBar = document.getElementById('sticky-atc');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const mainBtn = document.querySelector('[id^="ProductSubmitButton-"]');

  if (!stickyBar || !stickyBtn || !mainBtn) return;

  // Mirror disabled state and label from main button
  function mirrorState() {
    stickyBtn.disabled = mainBtn.disabled;
    const label = mainBtn.querySelector('span');
    if (label) stickyBtn.querySelector('.sticky-atc__btn-text').textContent = label.textContent.trim();
  }

  mirrorState();

  new MutationObserver(mirrorState).observe(mainBtn, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  // Show bar when main button scrolls out of view
  new IntersectionObserver(function (entries) {
    stickyBar.classList.toggle('sticky-atc--visible', !entries[0].isIntersecting);
    stickyBar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
  }).observe(mainBtn);

  // Delegate click to main button so all existing form logic fires
  stickyBtn.addEventListener('click', function () {
    mainBtn.click();
  });
})();
